module.exports = __webpack_public_path__ + "static/media/material-play-music.f14a5957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material/material-play-music.png
// module id = 1119
// module chunks = 114